

import Button from "@shared/components/button";
import analysisCard from "@shared/saas-components/ToolsCard.vue";
import Input from "@shared/input";
import Table from "@shared/components/table";
import Loader from "@shared/loader";
import nLoader from "@shared/components/n-loader";
import Pagination from "@shared/saas-components/pagination/index";
import VueMultiselect from "@shared/saas-components/vue-multiselect/index";
// import "vue-multiselect/dist/vue-multiselect.min.css";
import mainAxios from "@/axios";
import osintAxios from "@shared/light-ray/axios/osint-axios";
import {map, extend, isEmpty, startCase, toLower, get, uniqBy, uniq, cloneDeep} from "lodash";
import {setUsernamesDropdownData, csvFileName, convertToCSV} from "@shared/utils/functions";
import modalCompanyDetails from "@shared/saas-components/modal-company-details";
import {mapGetters, mapMutations, mapActions} from "vuex";
import blackAxios from "@/axios";
import JsonCSV from "vue-json-csv";
import poderResults from "@shared/saas-components/poder-judicial-results";
import poderResultsMore from "@shared/saas-components/poder-judicial-more";
import { CORPORATE_TOOL_MAPPING} from "@shared/utils/constants";
import {EventBus} from "@/main.js";
import neoSwitch from "@shared/components/toggle-switch";
import {DateTime} from "luxon";
import toolsHelper from "@shared/tools/mixins/toolsHelper";
import runAllQueries from "@shared/tools/mixins/runAllQueries";
import PermissionsMixin from "@shared/tools/mixins/permissions";
import tabsTools from "@shared/light-ray/pages/entity-details/tabs.vue"
import { companyIdentifierTabs } from "@shared/tools/utils/toolsTabs.js"
import AllTabs from "@shared/light-ray/assets/svg/entity-details/all_tabs.svg";
import {monitoringSearchData, monitoringHistoryData} from "@shared/utils/monitoringTools.js";
import MonitoringFilter from "@shared/saas-components/monitoring-filter";
import DatePicker from "vue2-datepicker";
import loader from "@shared/components/neo-layout/loader";
import { getIconsData } from "@shared/light-ray/services";
import { checkPermission } from "@shared/utils/functions";
import Field from "@shared/tools/components/Field.vue";
import CheckToolPagination from "@shared/tools/components/check-tool-pagination.vue";

export default {
    name: "company-identifier",
    components: {
        DatePicker,
        "neo-input": Input,
        "neo-button": Button,
        "neo-table": Table,
        "neo-pagination": Pagination,
        "neo-loader": Loader,
        analysisCard,
        VueMultiselect,
        "n-loader": nLoader,
        "download-csv": JsonCSV,
        "modal-company-details": modalCompanyDetails,
        poderResults,
        poderResultsMore,
        neoSwitch,
        tabsTools, 
        AllTabs,
        MonitoringFilter,
        loader,
        Field,
        CheckToolPagination
    },
    mixins: [toolsHelper, runAllQueries, PermissionsMixin],
    provide () {
      return {
        isCaseCreated: this.isCaseCreated
      }
    },
    props: {
        mainEntity: {
            type: Array,
            default: () => [],
        },
        toolData: {
            type: Array,
            default: () => [],
        },
        tool: {
            type: String,
            default: "",
        },
        searchQueries: {
            type: Array,
            default: () => [],
        },
        isQueryPanelExpanded: {
            type: Boolean,
            default: false,
        },
        toolSearchQueries: Array,
        monitoring: {
            type: Boolean,
            default: false,
        },
        frequency: {
            default: "",
        },
        /**
         * @typedef {Object} AutorunConfig
         * @property {Object} headers
         * @property {Object} params
         */
        /**
         * @type {AutorunConfig} autorun configurations
         */
        autorun: {
            type: Object,
            default: null,
        },
        title: {
            type: String,
            default: "Poder Judicial",
        },
        checkId: {
            type: String,
            default: "",
        },
        entityId: {
            type: String,
            default: "",
        },
        isCaseCreated: {
            type: Boolean,
            default: false,
        },
        listDisabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            loadingAllData: true,
            filterJurisdiction: null,
            isLoading: false,
            perPageOptions: [10, 20, 50, 100],
            
            allFilters: [],
            plantiffFilter: null,
            sourceTypeFilter: null,
            defandantFilter: null, 
            detailsFilter: null,
            details: "",
            showFiltersPanel: false,
            monitoringActive: false,
            riskCategoriesOptions: [],
            currentEntity: "",
            typehead: false,
            cardStatusResults: [],
            cardDetailsMap: {},
            tabsStatus: companyIdentifierTabs.tabsModel,
            dnbCheck: false,
            case_id: "",
            queries: [],
            isAllRunQueries: false,
            page_number: 1,
            items_count: 10,
            entityType:"person",
            // judicialDetails: [],
           
            searchMode: {
                label: "Search Mode",
                value: {
                    name: "Exact Match",
                    value: "exact_match",
                },
                props: {
                    options: [
                        {
                            name: "Exact Match",
                            value: "exact_match",
                        },
                        {
                            name: "Part Match",
                            value: "part_match",
                        },
                    ],
                    // maxHeight: 250,
                    placeholder: "Select Search Mode",
                    tagPlaceholder: "",
                    closeOnSelect: true,
                    showLabels: false,
                    allowEmpty: false,
                    checkboxes: true,
                    trackBy: "value",
                    label: "name",
                },
                //sisSourceSpecific: true,
            },
            officer: "",
            showCurpId: false,
            fullName: "",
            companyFullName: "",
            domainCompanyDetails: {},
            companyDetails: null,
            loaderController: {
                companySearch: {
                    loading: false,
                    success: false,
                    filterLoading: false,
                    filterSuccess: false,
                },
            },
            alertMessage: {
                success: null,
                error: null,
            },
            searchKeyword: "",
            selectedItem: null,
            allUsers: [],
            csvData: {
                company: [],
            },
            csvFields: [],
            modalCompanyDetailsData: null,
            jurisdiction: null,
            jurisdictionList: [],
            status: null,
            defandant: null,
            location: null,
            date:null,
            caseType:null,
            caseNumber:null,
            locationFilter: null,
            dateFilter:null,
            caseTypeFilter:null,
            caseNumberFilter:null,
            plantiff: null,
            showResult: false,
            triggerRoute: true,
            tabName: "",
            totalResults: 0,
            sourcesCall: null,
            showSearch: true,
            showMoreInfo: false,
            modalCompanyDetailsDataMore: [],
            newEntity: null,
            entityCount: 1,
            selectedCard: null,
            sourceType: null,
            jurisdictionType: null,
            searchQuery: "",
            currentQuery: -1,
            selectVal: [""],
            searchClicked: false,
            sources: [],
            bulkMonitor: false,
            isSavedLoading: {
                loading: false,
                loadingCardIndex: null,
            },
            request_id: null,
            monitoringStatus: false,
            isloadingDetails: false,
            isBulkMonntoringLoading: false,
            timeline: [],
            isOldVersionSelected: false,
            latestVersionResultsCount: 0,
            apiCallPages: 1,
            isComparisonModeOn: false,
            nerFilters: false,
            getReadOnlyMode: false,
            totalCount: 0,
            cardStatusCounts: {
                all:0,
                confirmedCount: 0,
                unknownCount: 0,
                potentialCount: 0,
                irrelevantCount: 0
            },
            isAdvancedSearch: false,
            showRFCId: false,
            rfcId: "",
            curpId: "",
            nameSearches: [],
            fullNameSearches: [],
            fetchMoreDetails: {},
            dateRange : [],
            appliedFilterCount: 0,
            isModalVisible: true,
            source:"poder",
            sourcetitle:"poder",
            sourcevalue:"poder",
            curpInfo: null,
            rfcInfo: "",
        };
    },
    computed: {
        ...mapGetters([
            "getNoMatchesFlag",
            "getSelectedEntity",
            "getResearchData",
            "getSelectedToolQuery",
            "getNeoCaseId", 
            "getProduct", 
            "getAllToolsData",
            "getAllMonitoringData", 
            "getCaseCompanies", 
            "getCasePersonalData", 
            "searchedQueries", 
            "getPermissions", 
            "checkPermissionsFetched", 
            "getMonitoringDateFilter", 
            "getAllToolNames",
            "getUserFeatures",
            "getJudicialDetailsSearchList",
            // "getDomainCompanyDetailsSearchList",
            "getCheckDescription"
            // "getAutoPopulatedCountryList",
        ]),

        tabsStatusList() {
            return this.tabsStatus.list.map(i=>({
                ...i,
                label: this.$t(`components.light_ray.${i.label}`?.toLowerCase())
            }))
        },
        
        computedNameSearches() {
            return this.nameSearches?.map(item => ({
                ...item,
                tGroup: this.$t(item.tGroup)
            }));
        },
        computedFullNameSearches() {
            return this.fullNameSearches?.map(item => ({
                ...item,
                tGroup: this.$t(item.tGroup)
            }));
        },
        judicialDetails: {
            get() {
                console.log(this.getJudicialDetailsSearchList)
                return this.getJudicialDetailsSearchList;
            },
            set(val) {
                this.SET_JUDICIAL_DETAILS_SEARCH_LIST(val);
            },
        },

        isSearchButtonEnabled(){
            if(this.fullName||this.rfcId||this.companyFullName||this.curpId)
                return false
            else return true
        },

        getHiddenTabs() {
            // return this.isCaseCreated ? [] : companyIdentifierTabs.hiddenTabs
            return [];
        },

        getTimelineData() {
            return this.timeline
        },
        monitoringAllowed() {
            return this.getUserFeatures.includes("corporate_record__monitoring")
        },

        formattedDate() {
            let formatDate = [];
            if (this.dateRange?.length) {
                let start = this.dateRange[0];
                start = DateTime.fromMillis(start);
                start = start.toFormat("yyyy-MM-dd");
                let end = this.dateRange[1];
                end = DateTime.fromMillis(end);
                end = end.toFormat("yyyy-MM-dd");
                formatDate = [start, end];
            }
            return formatDate;  
        },
        getHeight() {
            let card = document.getElementById("case-list")?.scrollHeight;
            let tabs = document.getElementById("dashboard-tabs")?.scrollHeight || 0;
            let header = document.getElementById("disclaimer")?.offsetHeight || 0;
            if (header && card) {
                return `height:${card - (tabs + header)}px`;
            } else return `height:100%`;
        },
        isToolActive() {
            let toolActive = this.getAllToolNames?.children?.find((el) => {
                if (el.activeProcess === "company-name") {
                    return el;
                }
            });
            if (toolActive) {
                return toolActive.active;
            } else return true;
            // return false;
        },

        searchQueryExists() {
            if (this.autorun) return true;
            
            if (!this.toolSearchQueries?.length) return false

            let flag = true;
            if (this.toolSearchQueries.findIndex((el) => el._id === this.getSelectedToolQuery?.query_id) < 0) flag = false;
            return flag;
        },

        fetchAllData() {
            if (this.getResearchData.personalDetails?.length || this.getResearchData.socialProfiles?.length) {
                this.getToolData();
            }
        },

        isMoreOpenCorporate() {
            let totalOpenCorporatePages = parseInt(this.totalOpenCorporateResults / 10, 10);
            if (this.totalOpenCorporateResults % 10) totalOpenCorporatePages += 1;

            let totalPages = parseInt(this.totalResults / 10, 10);
            if (this.totalResults % 10) totalPages += 1;

            if (totalPages < totalOpenCorporatePages) return true;
            else return false;
        },

        isCompanyEntity() {
            let flag = false;
            if (this.fieldType.value === "company") {
                flag = true;
            } else {
                for (let i = 0; i < this.queries.length; i++) {
                    if (this.queries[i].type.value === "company") {
                        flag = true;
                        break;
                    }
                }
            }
            return flag;
        },

        isPersonEntity() {
            let flag = false;
            if (this.fieldType.value === "officer") {
                flag = true;
            } else {
                for (let i = 0; i < this.queries.length; i++) {
                    if (this.queries[i].type.value === "officer") {
                        flag = true;
                        break;
                    }
                }
            }
            return flag;
        },

        query() {
            let query = "";
            if (this.searchKeyword || this.officer || this.address) query = this.searchKeyword || this.officer || this.address;
            else if (this.registry) {
                let result = [];
                result.push(this.registry?.firstName);
                result.push(this.registry?.middleName);
                result.push(this.registry?.lastName);
                query = result.join(" ");
            }
            return query;
        },

        getStatusList() {
            let data = [];
            if (this.fieldType.value === "officer") {
                let openCorporatesResults = this.domainCompanyDetailsSearch?.filter((company) => company?.key === "officer");
                if (this.openCorporatesCheck && openCorporatesResults?.length) {
                    // data = ["Active"];
                    let flag = false;
                    this.domainCompanyDetailsSearch?.forEach((company) => {
                        if (company?.inactive && company.key === "officer" && !flag) {
                            flag = true;
                        } else if (!data.includes("Active") && !data.includes("Inactive")) {
                            if (company?.api_all_data?.officer?.inactive === true) data.push("Inactive");
                            else if (company?.api_all_data?.officer?.inactive === false) data.push("Active");
                        }
                        return;
                    });
                    if (flag && !data.includes("Inactive")) data.push("Inactive");
                }
                if (this.clarifiedByCheck) {
                    this.domainCompanyDetailsSearch?.forEach((company) => {
                        if (!data.includes(company?.status) && company.key === "officer_clarifiedBy") {
                            if (company?.status) data.push(company?.status);
                        }
                    });
                }
            } else if (this.fieldType.value !== "officer") {
                this.domainCompanyDetailsSearch?.forEach((company) => {
                    if (!data.includes(company?.status)) {
                        if (company?.status) data.push(company?.status);
                        else data.push("Not available");
                    }
                    if (!data.includes("Active")) {
                        if (company?.api_all_data?.company?.inactive === false) data.push("Active");
                    }
                    if (!data.includes("Inactive")) {
                        if (company?.api_all_data?.company?.inactive === true) data.push("Inactive");
                    }
                });
            }
            return [{group: "Status", categories: uniq(data)}];
        },

        getCaseNumberList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                if (!data.includes(detail?.data?.objExpediente?.exp_toca)) {
                    if (detail?.data?.objExpediente?.exp_toca) data.push(detail?.data?.objExpediente?.exp_toca?.toLowerCase());
                    else data.push("Not available");
                }
            });
            return [{group: "caseNumber", tGroup: this.$t('components.tools.poder.case_number'), categories: uniq(data)}];
        },

        getPlantiffList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                console.log(detail)
                if (!data.includes(detail?.data?.objExpediente?.exp_actor)) {
                    if (detail?.data?.objExpediente?.exp_actor) data.push(detail?.data?.objExpediente?.exp_actor?.toLowerCase());
                    else data.push("Not available");
                }
            });
            console.log(data)
            return [{group: "plantiff", tGroup: this.$t('components.tools.poder.plantiff'), categories: uniq(data)}];
        },

        getDatesList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                detail?.data?.objAcuerdos.forEach(el => {
                    if (!data.includes(el.acu_fecha)) {
                        if (el.acu_fecha) data.push(el.acu_fecha);
                        else data.push("Not available");
                    }
                })
                    
            });
            return [{group: "Date", categories: uniq(data)}];
        },

        getLocationList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                if (!data.includes(detail?.data?.objExpediente?.exp_region) ) {
                    if (detail?.data?.objExpediente?.exp_region) data.push(detail?.data?.objExpediente?.exp_region?.toLowerCase());
                    // else data.push("Not available");
                }
                if (!data.includes(detail?.data?.objExpediente?.exp_ciudad) ) {
                    if (detail?.data?.objExpediente?.exp_ciudad) data.push(detail?.data?.objExpediente?.exp_ciudad?.toLowerCase());
                    // else data.push("Not available");
                } if (!data.includes(detail?.data?.objExpediente?.exp_estado) ) {
                    if (detail?.data?.objExpediente?.exp_estado) data.push(detail?.data?.objExpediente?.exp_estado?.toLowerCase());
                    // else data.push("Not available");
                } if(data.length == 0) 
                    data.push("Not available");
            });
            return [{group: "Location", tGroup: this.$t('components.tools.poder.location'), categories: uniq(data)}];
        },
        getTypeList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                if (!data.includes(detail?.data?.objExpediente?.exp_tipo)) {
                    if (detail?.data?.objExpediente?.exp_tipo) data.push(detail?.data?.objExpediente?.exp_tipo?.toLowerCase());
                    else data.push("Not available");
                }
            });
            return [{group: "CaseType", tGroup: this.$t('components.tools.poder.case_type'), categories: uniq(data)}];
        },

        getDefandantList() {
            let data = [];
            this.judicialDetails?.forEach((detail) => {
                if (!data.includes(detail?.data?.objExpediente?.exp_demandado)) {
                    if (detail?.data?.objExpediente?.exp_demandado) data.push(detail?.data?.objExpediente?.exp_demandado?.toLowerCase());
                    else data.push("Not available");
                }
            });
            return [{group: "Defandant", tGroup: this.$t('components.tools.poder.defandant'), categories: uniq(data)}];
        },  
        

       
       


        // hasMorePages() {
        //     if (this.page_number * this.items_count > this.domainCompanyDetailsSearchList.length) return false;
        //     return true;
        // },
        getTotalPages() {
            this.judicialDetailsSearchList = this.judicialDetailsSearchList
                .filter(item => item.api_all_data?.doc_id) // Remove entries with no doc_id
                .filter((item, index, self) =>
                    index === self.findIndex(t => t.api_all_data.doc_id === item.api_all_data.doc_id)
                );
            return Math.ceil(this.judicialDetailsSearchList?.length / this.items_count);
        },
        


        judicialDetailsSearchList() {
            let data = this.judicialDetails?.filter((ele) => ele?.data?.objExpediente?.exp_actor?.toLowerCase().includes(this.searchQuery?.toLowerCase()));
            if (this.plantiff) {
                data = data.filter((company) => company?.data?.objExpediente?.exp_actor.trim().toLowerCase() === this.plantiff?.trim().toLowerCase()  || (this.plantiff === "Not available" && !company?.data?.objExpediente?.exp_actor?.trim().toLowerCase()));
            }
            if (this.defandant) {
                data = data.filter((company) => company?.data?.objExpediente?.exp_demandado.trim().toLowerCase() === this.defandant?.trim().toLowerCase() || (this.defandant === "Not available" && !company?.data?.objExpediente?.exp_demandado?.trim().toLowerCase()));
            }
            if ( this.location) {
                data = data.filter((company) => (company?.data?.objExpediente?.exp_region?.trim().toLowerCase() === this.location?.trim().toLowerCase() || (this.regionType === "Not available" && !company?.data?.objExpediente?.exp_region?.trim().toLowerCase()))
            || (company?.data?.objExpediente?.exp_ciudad?.trim().toLowerCase() === this.location?.trim().toLowerCase() || (this.regionType === "Not available" && !company?.data?.objExpediente?.exp_ciudad?.trim().toLowerCase())) ||
            (company?.data?.objExpediente?.exp_estado?.trim().toLowerCase() === this.location?.trim().toLowerCase() || (this.regionType === "Not available" && !company?.data?.objExpediente?.exp_estado?.trim().toLowerCase())));
            }
            if ( this.caseType) {
                data = data.filter((company) => company?.data?.objExpediente.exp_tipo?.trim().toLowerCase() === this.caseType || (this.caseType === "Not available" && !company?.data?.objExpediente?.exp_tipo?.trim().toLowerCase()));
            }
            if ( this.caseNumber) {
                data = data.filter((company) => company?.data?.objExpediente.exp_toca?.trim().toLowerCase() === this.caseNumber || (this.emailType === "Not available" && !company?.data?.objExpediente?.exp_toca?.trim().toLowerCase()));
            }
            if (this.formattedDate?.length) {
                data = data.filter((company) => (new Date(company?.data?.objExpediente?.exp_fecha) >= new Date(this.formattedDate[0]) && new Date(company?.data?.objExpediente?.exp_fecha) <= new Date(this.formattedDate[1])) || 
                (this.formattedDate[0].split('-')[0] >= company?.data?.objExpediente?.exp_anio && this.formattedDate[1]?.split('-')[0] <= company?.data?.objExpediente?.exp_anio || (this.formattedDate?.length === 0 && !company?.objExpediente?.exp_fecha)));
            }
            
            return data;
            
        },



        allUsersList() {
            return [{group: "Company Name", categories: this.allUsers}];
        },
        searchedQueryKeyword() {
            if (this.fieldType.value === "company") {
                return this.searchKeyword;
            }
            if (this.fieldType.value === "officer") {
                return this.officer;
            }
            if (this.fieldType.value === "address") {
                return this.address;
            }
            if (this.fieldType.value === "registry") {
                return Object.values(this.registry)
                    .map((ele) => ele)
                    .join(" ")
                    .replace(new RegExp("\\s{2,}", "gm"), " ");
            }
        },
        selectedQuery() { 
             var findData = this.searchedQueries.filter(x => x.tool == "poder-tool").find((data) => {
                if (this.entityType === "company") {
                    return data?.query?.company_name == this.companyFullName?.value || data?.query?.rfc_id == this.rfcId
                } else if (this.entityType === "person") {
                    return data?.query?.full_name == this.fullName?.value || data?.query?.curp_id == this.curpId
                }
                return false
            });

            if (!findData) return null;

            let maskedQuery = this.viewQuery(findData);
            findData.query_payload = {
                query_id: findData?._id,
                query_string: maskedQuery,
                search_string: maskedQuery,
            };
            return findData
        },
        // bvd__corp_record
        bvdSourceAuth() {
            return this.getUserFeatures.includes("bvd__corp_record");
        },
        // dbCorpRecord() {
        //     return this.getUserFeatures.includes("db__corp_record");
        // },
        // dbResellerCorpRecord() {
        //     return this.getUserFeatures.includes("dnb_reseller__corp_record");
        // },
        // clarifiedBySourceAuth() {
        //     // if (this.$route.name === "tools") {
        //     return false
        //     // }
        // },
        // companyWatchSourceAuth() {
        //     // if (this.$route.name === "tools") {
        //     return false
        //     // }
        // },
        // openCorpSourceAuth() {
        //     // if (this.$route.name === "tools") {
        //     return this.getUserFeatures.includes("open_corporates__corp_record");
        //     // }
        // },
        // checkMarkAllDone() {
        //     let searchedResultList = [];
        //     searchedResultList = this.domainCompanyDetailsSearchList.slice(this.items_count * (this.page_number - 1), this.page_number * this.items_count);
        //     if (searchedResultList && searchedResultList.length) return searchedResultList.every((result) => result.api_all_data.changes_viewed);
        //     else return false;
        // },
        // checkBulkToggleOn() {
        //     let searchedResultList = [];
        //     searchedResultList = this.domainCompanyDetailsSearchList;
        //     if (searchedResultList && searchedResultList.length) {
        //         this.isBulkMonitorOn = searchedResultList.every((result) => result.api_all_data.monitoring_status);
        //         return searchedResultList.every((result) => result.api_all_data.monitoring_status);
        //     } else return false;
        // },

        allSourcesChecked() {
            let allSourcesChecked = false;
            if (this.openCorporatesCheck && this.clarifiedByCheck && this.companyWatchCheck && this.bvdCheck) {
                allSourcesChecked = true;
            }
            return allSourcesChecked;
        },
        isMonitoringTab() {
            return this.$route.name === "monitoring";
        },

        last_run_date() {
            const querySource = this.autorun ? this.selectedQuery : this.getSelectedToolQuery?.query;
            return querySource?.last_runtime;
        },
        allCount(){
            return this.judicialDetailsSearchList.length == 100 ? this.totalRecordsInAllQueries : this.judicialDetailsSearchList.length 
        },
    },
    async created() {
        if (this.autorun) this.isLoading = true;
        EventBus.$on("handleDone", (data) => {
            let allResults = cloneDeep(this.domainCompanyDetailsSearch);
            if (!data.oldVersion) {
                let cardIndex = allResults?.findIndex((res) => res?.api_all_data?.doc_id === data?.card?.api_all_data?.doc_id);
                let cardResult = allResults[cardIndex];
                allResults.splice(cardIndex, 1, cardResult);
                this.domainCompanyDetailsSearch = allResults;
            } else {
                let oldVersionResults = cloneDeep(this.timeline);
                let index = oldVersionResults.findIndex((el) => el.curr_index === data.curr_index);
                if (index > -1) {
                    oldVersionResults[index] = data.card;
                    this.timeline = oldVersionResults;
                    // this.checkMarkAllDone()
                }
            }
            this.$forceUpdate();
        });

        EventBus.$on("handleResultCorporateSave", (data) => {
            // API Call to save card
            this.handleSavedCard(data);
        });

        EventBus.$on("handleMonitoring", (data) => {
            let allResults = cloneDeep(this.domainCompanyDetailsSearch);
            let cardIndex = data.index
            // TO DO
            // Card index is bit different in domainCompanyDetailsSearch with selected one
            // right now using the selected card index which we are passing in data params
            // let cardIndex = allResults?.findIndex((res) => res?.api_all_data?.doc_id === data?.card?.api_all_data?.doc_id);
            if (cardIndex > -1) {
                let cardResult = allResults[cardIndex];
                allResults.splice(cardIndex, 1, cardResult);
                this.domainCompanyDetailsSearch = allResults;
            }
            this.$forceUpdate();
        });
     
        EventBus.$on("showMoreData", (data) => {
            this.showMoreData(data);
        });
        EventBus.$on("fetchReport", (data) => {
            this.fetchReport(data);
        });
        EventBus.$on("handleExpandAllPanel", (data) => {
            this.handleExpandAllPanel(data);
        });
    },
    async mounted() {
        this.SET_QUERIES_LOADER(true)
        
       
        this.setMonitoring(true)
        
        this.setDefaultFilters()
        await this.getRiskCategoriesOptions()
        this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
        // this.$emit("getQueriesMonitoring")
        // await this.getJurisdiction();
        // await this.getDnbJurisdiction();
        // await this.updateMonitoringCount()
        
        if (!this.$store.getters?.getIconsData.length) {
            const iconsdata = await getIconsData();
            this.$store.commit("SET_ICONS_DATA", iconsdata?.data.icons_data ?? []);
        }

        let dataRes; // use for the cached data storage if configured properly
        // TODO consider all cases when this data must be reset to use it:
        dataRes = this.getToolsData("company-name");

        this.currentEntity = this.$route.query.entityId;
        if (dataRes && dataRes?.entityId === this.currentEntity) {
            // TODO check this condition when WLP 5.0 is ready
            if (!this.autorun) {
                this.redirectToQuery(dataRes);
            }
        } else {
            this.monitoringActive = false
            this.showResult = false
            this.showSearch = true
            // this.triggerRoute = false;
            this.clarifiedByCheck = false
            this.companyWatchCheck = false
            this.bvdCheck = false
            this.openCorporatesCheck = false;
            this.selectVal = []
        }
        const entityName = this.prebuiltQueryPayload?.name
        || this.getSelectedEntity?.entity_name;

        if (this.getSelectedEntity?.entity_type=='Company') {
            this.entityType = 'company'
            this.companyFullName = {
                value: entityName
            };
        }
        else if  (this.getSelectedEntity?.entity_type=='Person') {
            this.entityType = 'person';
            this.fullName = {
                value: entityName
            }

        }
        this.searchKeyword = entityName;
        await this.getToolData();
        await this.getToolsStatus();
        // await this.setAutoPopulateValue();
        if (this.autorun) {
            await this.autoInit();
        } else if (this.toolSearchQueries?.length){
            this.$emit("selectAllQueries");
        }

        this.SET_QUERIES_LOADER(false);
        this.loadingAllData = false;
        this.resetSelectedTab();
    },
    watch: {
        // "$route.query"() {
        //     if (this.triggerRoute) {
        //         this.redirectToQuery();
        //         this.currentQuery = -1;
        //     }
        // },
        showResult() {
            this.$el.scroll(0, 0);
        },
       
    },
    beforeDestroy() {
        // ! currently, we can't use cached data
        // TODO consider all cases when data must be reset to use this:
        // this.setToolsData("company-name"); // commented to not load memory

        this.SET_JUDICIAL_DETAILS_SEARCH_LIST([]);

        EventBus.$off("handleDone");
        EventBus.$off("handleResultCorporateSave");
        EventBus.$off("handleExpandAllPanel");
        EventBus.$off("fetchReport");
        EventBus.$off("showMoreData");
    },
    methods: {
        ...mapMutations([
            "SET_ALL_TOOLS_DATA",
            "SET_ALL_MONITORING_DATA",
            "SET_TOOLS_DATA",
            "SET_QUERIES_LOADER",
           "SET_JUDICIAL_DETAILS_SEARCH_LIST",
        ]),
        checkPermission,
        async afterSearchResponseReceived({ searchResults = [] }) {
            const { checks, case_id, id } = this.getSelectedEntity;
            const checkId = this.isCaseCreated ? this.checkId : checks?.find(x => x.check_id == this.checkId)?.id;
            try {
                await this.refreshCheckToolSelfStatus({
                    caseId: case_id,
                    entityId: id,
                    checkId: checkId,
                    searchResults,
                    options: {
                        refreshCheckStatus: this.isCaseCreated
                    }
                });
            } catch {
                console.error('error::afterSearchResponseReceived')
            }
        },
        onPerPageChange(itemsCount) {
            this.items_count = itemsCount;
            this.page_number = 1;
        }, 
        async fetchMoreData(details) {
            let payload = {
                doc_id: details.api_all_data.doc_id,
                request_id: details.api_all_data.query_id,
            };
            let response = await osintAxios.post("/api/v1/db/meta-deta/fetch-more-data", payload);
            this.fetchMoreDetails = response.data.data[0];
        },
        jurisdictionSelection() {
            if (this.dbJurisdiction !== null) {
                this.selectedJurisdiction = false;
            }
        },
        advancedSearch() {
            if (!this.isAdvancedSearch) {
                this.registrationNumber = "";
                this.dbaddress = "";
                this.postCode = "";
                this.locality = "";
                this.region = "";
                this.phone = "";
                this.duns = "";
                this.selectedJurisdiction = false;
                this.email = "";
            }
        },
        ...mapActions(["getAnalysisDropdownData", "getAllCaseCompanies", "getToolsStatus", "refreshCheckToolSelfStatus", "setQueryResultLoader"]),
        
        async getDnbJurisdiction() {
            let url = "/api/v1/db/jurisdiction_master";

            await osintAxios
                .get(url)
                .then((response) => {
                    if (response && response.data) {
                        this.dbJurisdictionList = [{group: "Any", categories: response.data.data.country_details}];
                    }
                })
                .catch((error) => {console.log(error)});
        },
        onInput(value, field) {
            if (value)
                this[field] = {
                    name: value,
                    value: value,
                };
            else this[field] = null;
        },

        closeDropdown(ref, field) {
            this.$refs[ref].search = field?.value ?? "";
        },
        async updateMonitoringCount() {
            const payload = {
                minDate: this.dateFilters.minDate,
                maxDate: this.dateFilters.maxDate,
                tool: this.$route.query.check_name || this.autorun?.headers['x-tool-name'],
            }
            await this.getQueryMonitoringEvents(payload)
        },
        async getCountriesList() {
            // let countries = [];
            await osintAxios
                .get("/api/v1/search-engine/location")
                .then((response) => {
                    if (response && response.data) {
                        const country = response.data.data.map((el) => ({
                            label: el.country,
                            value: el.country_code,
                            option: el.country_cr_code,
                        }));
                        this.countriesOptions = [
                            {
                                group: "Countries",
                                categories: country,
                            },
                        ];
                        this.$store.dispatch("storeAllCountryList", country);
                    }
                })
                .catch(() => {});
        },

        getDob() {
            if (
              this.BVDDateOfBirth?.drops &&
              this.BVDDateOfBirth?.drops[0]?.value &&
              this.BVDDateOfBirth?.drops[1]?.value &&
              this.BVDDateOfBirth?.drops[2]?.value
            ) {
              let year = this.BVDDateOfBirth.drops?.[0]?.value?.toString();
              let month = this.BVDDateOfBirth.drops?.[1]?.value
                ? (
                    this.BVDDateOfBirth.drops?.[1]?.props?.options?.findIndex(
                      (idx) => idx === this.BVDDateOfBirth.drops?.[1]?.value
                    ) + 1
                  )
                    ?.toString()
                    .padStart(2, "0")
                : "";
              let date = this.BVDDateOfBirth.drops?.[2]?.value
                ?.toString()
                .padStart(2, "0");
              return year + "-" + month + "-" + date;
            } else {
              return "";
            }
            
        },

        fillYears() {
          try {
            const now = new Date().getUTCFullYear();
            this.dayOptions = Array(31)
              .fill("")
              .map((i, idx) => idx + 1);
            (this.monthOptions = [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ]),
              (this.yearOfBirthOptions = Array(now - 1899)
                .fill("")
                .map((v, idx) => now - idx));
            // this.yearOfBirth.props.options = this.yearOfBirthOptions;
         
            this.BVDDateOfBirth.drops[2].props.options = this.dayOptions;
            this.BVDDateOfBirth.drops[1].props.options = this.monthOptions;
            this.BVDDateOfBirth.drops[0].props.options = this.yearOfBirthOptions;
          } catch (err) {
            console.log("err", err);
          }
        },
        setDefaultFilters() {
            this.allFilters = []
            this.selectedDataType = {label: "All Results", value: "All"}
            
        },
       
        async getRiskCategoriesOptions() {
            try {   
                let headers = { "x-case-id": this.getNeoCaseId }
                const url = '/service/risk-categories'
                let categories = await mainAxios.get(url, {headers});
                this.riskCategoriesOptions = categories.data.risk_data
            } catch (err) {
                console.log(err)
            }
        },

        async filterData() {
            await this.handleApplyFilters();
        },

        async handleApplyFilters() {
            this.allFilters = []
            this.defandant = this.defandantFilter;
            this.plantiff = this.plantiffFilter;
            this.location = this.locationFilter;
            this.caseNumber = this.caseNumberFilter;
            this.caseType = this.caseTypeFilter;
            // this.date = this.dateFilter;
            // this.details = this.detailsFilter


            let allFilters = ["defandantFilter", "plantiffFilter", "locationFilter", "caseNumberFilter", "caseTypeFilter", "detailsFilter"];

            this.allFilters = [];
            let that = this;
            for (let filter in allFilters) {
                let filterValues = get(that, allFilters[filter]);
            
                if (filterValues) {
                    this.allFilters.push({
                        name: allFilters[filter],
                        value: allFilters[filter] === 'filterJurisdiction' ? filterValues.label : filterValues,
                    });
                }
            }

            if (this.formattedDate?.length) {
                this.allFilters.push({value:`${this.formattedDate[0]} To ${this.formattedDate[1]}`})
                this.appliedFilterCount = 2;
                
            }

            if (this.searchQuery) this.appliedFilterCount += 1;
            if (this.defandantFilter) this.appliedFilterCount += 1;
            if (this.plantiffFilter) this.appliedFilterCount += 1;
            if (this.locationFilter) this.appliedFilterCount += 1;
            if (this.caseNumberFilter) this.appliedFilterCount += 1;
            if (this.caseTypeFilter) this.appliedFilterCount +=1;
            // if (this.detailsFilter) this.appliedFilterCount +=1;

            this.setCardStatusCounts()
        },

        async selectedRemoveFilters(filter) {
            // let match = -1;
            switch (filter.name) {
                case "monitoringActive":
                    this.selectedDataType = {label: "All Results", value: "All"};
                    break;
                case "monitoringDateRange":
                    this.dateRange = [];
                    break;
                default:
                    this[filter.name] = null;
                    break;
            }
            this.handleApplyFilters();
            
        },
        convertToCSV(arr) {
            return convertToCSV(arr);
        },
        csvFileNames(query) {
            return csvFileName('company-name', query, 'companies');
        },
        setCardStatusCounts() {
            if(this.isAllRunQueries){
                this.cardStatusCounts.all = this.totalRecordsInAllQueries
                this.cardStatusCounts.confirmedCount = this.totalStatusCount.CONFIRMED
                this.cardStatusCounts.unknownCount = this.totalStatusCount.UNKNOWN
                this.cardStatusCounts.potentialCount = this.totalStatusCount.POTENTIAL
                this.cardStatusCounts.irrelevantCount  = this.totalStatusCount.IRRELEVANT
            }
            else{
                this.cardStatusCounts.all = this.totalCount
                if (this.allFilters.length > 0) {
                    this.cardStatusCounts.confirmedCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'CONFIRMED').length
                        this.cardStatusCounts.unknownCount = this.judicialDetailsSearchList?.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length
                        this.cardStatusCounts.potentialCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'POTENTIAL').length
                        this.cardStatusCounts.irrelevantCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'IRRELEVANT').length
                }
                else {
                    this.cardStatusCounts.confirmedCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'CONFIRMED').length
                    this.cardStatusCounts.unknownCount = this.judicialDetailsSearchList?.filter((res) => !res.card_status || res.card_status === 'UNKNOWN').length
                    this.cardStatusCounts.potentialCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'POTENTIAL').length
                    this.cardStatusCounts.irrelevantCount = this.judicialDetailsSearchList?.filter((res) => res.card_status === 'IRRELEVANT').length
                }
            }
        },
        async updateCardStatus() {
            await this.getAllCardsDetails();
            this.selectToolsCardStatus(null, this.tabsStatus.selected);
            if (this.page_number > this.getTotalPages)
                this.page_number = this.getTotalPages;
        },
        async updateTabCount(){
            if(this.isAllRunQueries){
                this.isNextPag = true;
                await this.onRunAllQueries(null, "judicialDetails");
                this.setCardStatusCounts()
            }
            else{
                await this.updateCardStatus();
            }
        },
        async getAllCardsDetails() {
            const payload = {
                case_id: this.getNeoCaseId,
                query_id: this.$route.query.query_id,
                tool_name: this.$route.query.check_name,
                entity_id: this.$route.query.entityId
            }
            const url = '/service/card-results'
            const { data } = await blackAxios.post(url, payload)
            if (data?.data.length > 0) {
                data.data.forEach((res) => {
                    this.cardDetailsMap[res.card_id] = res
                })
            }
            this.timeline.forEach((res) => {

                res.card_status = this.cardDetailsMap[res.doc_id] && this.cardDetailsMap[res.doc_id].status != 'None' ? this.cardDetailsMap[res.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.screenshot : {}
            })
            this.timeline = cloneDeep(this.timeline)
            this.cardStatusResults.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.doc_id] && this.cardDetailsMap[res.doc_id].status != 'None' ? this.cardDetailsMap[res.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.screenshot : {}
            })
            this.judicialDetails.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.doc_id] && this.cardDetailsMap[res.doc_id].status != 'None' ? this.cardDetailsMap[res.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.doc_id] ? this.cardDetailsMap[res.doc_id]?.screenshot : {}
            })
            this.judicialDetails = cloneDeep(this.judicialDetails)
            this.setCardStatusCounts()
        },

        mapCardResultsData() {
            this.cardStatusResults.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status !== 'None' ?
                    this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
            this.domainCompanyDetailsSearch.forEach((res) => {
                res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status !== 'None' ?
                    this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                res.customer_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                res.research_notes = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
            })
        },

        setAutoPopulateValue(){
            const systemFieldsData = this.$store.getters.getSystemFields;
           
            if(systemFieldsData?.company_name?.length) {
                this.selectedItem = {
                    name: systemFieldsData?.company_name[0],
                    value: systemFieldsData?.company_name[0],
                };
              
            } 
            // Tax Id  
            
            if(this.entityType === "person") {
                if(!systemFieldsData?.person_first_name){
                    this.fullNameMode =  true;
                }
                const nameFields = [
                   
                    {
                        name: "fullName",
                        searchName: "fullNameSearches",
                        sysFieldKey: "alias_name",
                    },
                    
                  ];

            nameFields.forEach((fld) => {
                if (
                    systemFieldsData[fld.sysFieldKey] && systemFieldsData[fld.sysFieldKey]?.length
                  ) {
                    const isVisitedField = fld.sysFieldKey === "person_first_name";
                    const data = {
                      value: systemFieldsData[fld.sysFieldKey][0],
                      platform: "poder",
                      val_type: "name",
                      visited: isVisitedField,
                      entity_id: this.$route.query.entityId
                    };
                    this[fld.searchName][0]?.categories.push({
                      ...data,
                    });
                    this[fld.searchName][0].categories = uniqBy(
                        this[fld.searchName]?.[0]?.categories,
                      "value"
                    );
                    this[fld.searchName][0].categories = this[fld.searchName][0].categories.filter((el) => el?.platform == "poder" && el.entity_id == this.$route.query.entityId )
                    this.fullNameSearches[0].categories = this.fullNameSearches[0].categories.filter((el) => el?.platform == "poder" && el.entity_id == this.$route.query.entityId )
                  }
                  this[fld.name] = { value: systemFieldsData[fld.sysFieldKey]?.length ? systemFieldsData[fld.sysFieldKey][0]: "" };
            })
            }  
        },

        async selectToolsCardStatus(_, id) {
            if (this.tabsStatus.selected === id) return;
            if (this.timeline) {
                //    this.domainCompanyDetailsSearchList.forEach((res, index)=>{
                //        this.timeline.forEach((result, historyIndex)=>{
                //            if (index == historyIndex) {

                //            }
                //        })
                //    })
            }

            if (id !== this.tabsStatus.selected) this.page_number = 1

            this.tabsStatus.selected = id;
            if (this.isAllRunQueries) {
                this.isNextPag = true;
                this.offsetPag = 0;
                this.limitPag = 1;
                await this.onRunAllQueries(null, "judicialDetails");
                this.isNextPag = false;
                this.setCardStatusCounts();
            }
            if (id === "all") {
                this.judicialDetails = this.cardStatusResults
            } else if (id === "unknown") {
                this.judicialDetails = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === id)
            }  else if (id === "confirmed") {
                this.judicialDetails = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === id)
            }else if (id === "irrelevant") {
                this.judicialDetails = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === id)
            }else if (id === "potential") {
                this.judicialDetails = this.cardStatusResults.filter((res) => !res.card_status || res.card_status?.toLowerCase() === id)
            } else {
                this.judicialDetails = this.cardStatusResults.filter((res) => !res.card_status || res.card_status.toLowerCase() === id)
            }
            this.judicialDetails = this.judicialDetails
                .filter(item => item?.doc_id) // Remove entries with no doc_id
                .filter((item, index, self) =>
                    index === self.findIndex(t => t?.doc_id === item?.doc_id)
                );
            // this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({ ...ele, current_index: index }));

            this.handleCloseMoreInfo();
        },
        getMappingValue(data_values = [], source, mapValues, tag) {
            const result_dict = data_values.map((ele) => {
                let list = Object.entries(mapValues);
                const result = list.reduce((accumulator, item) => {
                    let keys = item[1][source].keys;
                    let separator = item[1][source].separator;
                    accumulator[item[0]] = keys
                        .map((key) => {
                            //Iterating inside array for fetching the values in "iterable_key"
                            if (item[1][source].iterable_key) {
                                return get(ele, key, []).map((el1) => get(el1, item[1][source].iterable_key, ""));
                            }
                            if (typeof item[1][source] === "object") {
                                return get(ele, key, []);
                            }
                            return get(ele, key, "N/A");
                        })
                        .filter((e) => e != null && e != "")
                        .join(separator ? separator : ", ");
                    return accumulator;
                }, {});
                result.key = source;
                result.sourceTag = tag;
                return { ...result, api_all_data: ele };
            });
            return result_dict;
        },
        resetPage() {
            this.page_number = 1;
            this.showMoreInfo = false;
            this.handleCloseMoreInfo();
        },
        resetStatus() {
            this.resetPage();
            this.showMoreInfo = false;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
            this.timeline = [];
            this.$emit("updateMonitoringCascadingTimeline", {
                timeline: this.timeline,
                meta_data: null,
            });
            if ((this.sourceType === "companyWatch" || this.sourceType === "bvd") && this.fieldType.value === "officer") this.status = "";
        },
        resetJurisdiction() {
            if (this.sourceType === "bvd" && this.fieldType.value === "officer") this.jurisdictionType = "";
        },
        loadMoreResults() {
            let page = parseInt(this.judicialDetails/ 100, 10);
            this.loadMoreDetails(page + 1);
        },
        async handleBulkMonitoring() {
            // const monitoringStatus = event.target.checked;
            const querySource = this.autorun ? this.selectedQuery.query_payload : this.getSelectedToolQuery;
            this.isBulkMonntoringLoading = true;
            this.bulkMonitor = true;
            this.isBulkMonitorOn = !this.isBulkMonitorOn;
            let requestBody = {
                product_name: this.getProduct.name,
                product_id: this.getProduct.key,
                case_id: this.getNeoCaseId,
                query: {
                    query_id: querySource.query_id,
                    query_string: querySource.query_string,
                    search_string: querySource.search_string,
                },
                frequency: this.$props.frequency ? this.$props.frequency : 30,
                status: this.isBulkMonitorOn ? "enabled" : "disabled",
            };
            try {
                const response = await mainAxios.post("/service/bulk-enable", requestBody);
                if (response.status) {
                    this.$toast.success(this.$t('components.tools.poder.bulk_monitoring_updated_successfully'));
                    this.bulkMonitor = false;
                    let details = this.domainCompanyDetailsSearch;
                    details.map((el) => {
                        el.api_all_data.monitoring_status = this.isBulkMonitorOn;
                    });
                    this.domainCompanyDetailsSearch = cloneDeep(details);

                    this.$forceUpdate();
                    // setTimeout(() => {
                    //     (this.manualSearch("true"),5000)
                    // });
                }
            } catch (error) {
                this.$toast.error(error.message);
            }
            this.isBulkMonntoringLoading = false;
        },

        async loadMoreDetails(page) {
            this.startLoader("companySearch");
            const headers = {
                "x-tool-name": "poder-tool",
                "x-visited": true,
                "x-refresh": true,
                "x-entity-id": this.$route.query.entityId,
                ...this.autorun?.headers,
            };
            console.log(page)
            let payload = {};
            let sources = ["poder"];
            payload.sources = sources;
            this.curpInfo = null;
            this.rfcInfo = null
            if(this.fullName && !this.showCurpId && !this.showRFCId) {
                if(this.searchMode.value.value === "exact_match")
                 payload.exact_name = this.fullName.value;
                else payload.full_name = this.fullName.value;
            }
            if(this.curpId && this.showCurpId) {
                payload.curp_id = this.curpId;
            }
            if(this.companyFullName && !this.showCurpId && !this.showRFCId) {
                payload.company_name = this.companyFullName.value;
            }
            if(this.showRFCId && this.rfcId) {
                payload.rfc_id = this.rfcId;
            }
            payload.request_id = this.request_id;
        
            let poder
             if(this.entityType == 'person') {
                if(this.showCurpId) {
                    poder = await osintAxios.post("/api/v1/poder/person/search/curp", payload, {headers});
                }
                if(this.searchMode.value.value === "exact_match" && this.fullName?.value?.length>0 && !this.showCurpId) {
                    poder = await osintAxios.post("/api/v1/poder/person/search/exact_name", payload, {headers});
                }
                else if(this.fullName?.value?.length && !this.showCurpId) {
                    poder = await osintAxios.post("/api/v1/poder/person/search/full_name", payload, {headers});
                }
            } else if(this.showRFCId) {
                poder = await osintAxios.post("/api/v1/poder/company/search/rfc", payload, {headers});
            } else if(this.entityType === 'company' && this.companyFullName && !this.showRFCId) {
                poder = await osintAxios.post("/api/v1/poder/company/search/name", payload);   
            }
            this.showResult = true
            // await this.getAllCardsDetails()

            if (poder) {
                this.totalCount = poder?.data?.total_results
                if (this.apiCallPages === 1) this.judicialDetails = [];
                await Promise.allSettled([poder])
                    .then(async (results) => {
                        let values = results.map((result) => result.value);
                        
                        if (this.apiCallPages === 1) this.judicialDetails = [];
                        // orbis
                        const poderData = values[0]?.data?.data;

                        if (poderData?.length > 0) {
                            this.judicialDetails = [...this.judicialDetails,poderData];
                            if(poderData[0]?.data?.curp_info)
                                this.curpInfo = poderData[0]?.data?.curp_info
                            if(poderData[0]?.data?.rfc_info)
                                this.rfcInfo = poderData[0]?.data?.rfc_info
                            this.showSearch = false;
                        }
                        if ((!results[0]?.status === "rejected" && values[0] && (!values[0]?.data?.data || values[0]?.data?.data?.length === 0)) ) {
                            if (values[0]?.data?.message) this.$toast.error(values[0]?.data?.message);
                            else this.$toast.error(this.$t('components.tools.poder.no_data_found'));
                        }
                        if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                            this.showSearch = false;
                            this.showResult = true;
                            this.$toast.error(this.$t('components.tools.poder.poder_something_went_wrong_please_try_again'));
                        }
                        this.cardStatusResults = this.judicialDetails
                        
                        
                            await this.getAllCardsDetails()
                            this.setCardStatusCounts()
                        
                        
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "poder-tool",
                        });
                        this.triggerRoute = true;
                        this.$emit("searchResult", {data: this.judicialDetails, source: "company", searchType: "name"});
                        if (this.judicialDetails.length <= 0) {
                            this.totalResults = 0;
                        } else {
                            this.judicialDetails = this.judicialDetails.map((ele, index) => ({...ele, current_index: index}));
                            this.totalResults = this.judicialDetails.length;
                        }
                        this.resetLoader("companySearch");
                        let configMissing = this.checkConfig(values)
                        if (configMissing.length>0) {
                            configMissing.forEach((mes)=>{
                                this.$toast.error(mes)
                            })
                            return
                        }
                        this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name });
                        await this.afterSearchResponseReceived({ 
                            searchResults: results 
                        });
                        this.$emit("updateToolData", "poder-tool");
                        
                    })
                    .catch((error) => {
                        if (error.response && error.response.status === 406) {
                            const message = error.response?.data?.detail || "Something went wrong. Please try again.";
                            this.$toast.error(message);
                        }
                        this.showSearch = false;
                        this.showResult = true;
                        this.resetLoader("companySearch");
                    });
            }
        
        },

        async autoInit() {
            try {
                this.isLoading = true;
                this.showSearch = false;
                this.bvdCheck = true;
                await this.manualSearch();
                await this.getAllCardsDetails();
                const confirmedCards = this.cardStatusResults.filter((res) => res.card_status === 'CONFIRMED');
                for (const index in confirmedCards)
                    this.handleCorporateRecordsConfirmation({
                        item: confirmedCards[index],
                        value: true
                    });
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },

        async manualSearch(refreshFlag = false) {
            if (!this.isRunCheckAllowed) {
                return this.showRunCheckError();
            }

            this.triggerRoute = false;
            this.showResult = true;
            await this.search(refreshFlag);
            this.isloadingDetails = false;
        },

       
        async getToolData() {
            const companies = await this.getDropdownData("company_name");
            this.nameSearches = [
                {
                    tGroup: 'components.tools.poder.entities',
                    categories: companies,
                },
            ];

            let persons = await this.getDropdownData("name");
            this.personSearches = [
                {
                    tGroup: 'components.tools.poder.entities',
                    categories: persons,
                },
            ];
            const full_names = [];
            persons = persons.forEach((name) => {
                const full = name.value;
                if (full)
                    full_names.push({
                        ...name,
                        value: full,
                    });
            });

            this.fullNameSearches = [
                {
                    tGroup: 'components.tools.poder.entities',
                    categories: uniqBy(full_names, "value"),
                },
            ];
        },

        async getDropdownData(field) {
            let data = this.toolData.filter((user) => user.val_type === field);
            return data;
        },

        handleChecked(data) {
            let allChecked = false;
            this.allUsers =  this.allUsers.filter((el) => el?.platform == "poder" && el.entity_id == this.$route.query.entityId)
            this.$emit("updateToolData", "poder", [...this.allUsers], data);
            allChecked = [...this.allUsers].length ? ([...this.allUsers].findIndex((n) => !n.visited) > -1 ? false : true) : false;

            this.$emit("handleChecked", allChecked);
        },

        setInput() {
            this.searchKeyword = this.selectedItem.value;
        },

        setTheCustomInput(value) {
            this.searchKeyword = value;
            this.selectedItem = {
                value: value,
            };
        },

        updateFieldType(i) {
            if (i >= 0) {
                this.queries[i].company = "";
                this.queries[i].officer = "";
                this.queries[i].address = "";
                this.queries[i].registry.firstName = "";
                this.queries[i].registry.middleName = "";
                this.queries[i].registry.lastName = "";
                this.queries[i].registry.nickname = "";
                this.isAllRunQueries = false;
            } else {
                this.officer = "";
                this.address = "";
                this.searchKeyword = "";
                this.selectedItem = "";
                this.jurisdiction = "";
                this.plantiff = "";
                this.sourceType = "";
                this.jurisdictionType = "";
                this.searchQuery = "";
                this.status = "";
                this.registry.firstName = "";
                this.registry.middleName = "";
                this.registry.lastName = "";
                this.registry.nickname = "";
                this.showResult = false;
                this.showSearch = true;
                this.isAllRunQueries = false;
                this.selectVal = [];
                this.csvData = {
                    company: [],
                };
                this.csvFields = [];
            }
        },

        async setSearchedUser(searchKeyword) {
            const data = {
                value: searchKeyword,
                platform: "poder",
                val_type: this.companyFullName ? 'company_name': 'name',
                visited: true,
                entity_id: this.$route.query.entityId
            };
            let url = `/service/${this.getNeoCaseId}/tools/profiles`;
            await setUsernamesDropdownData(url, data);
            // if (isSuccess) {
            let dataItem = this[`allUsers`].find((dataItem) => {
                return dataItem.value === searchKeyword;
            });
            if (dataItem) dataItem["visited"] = true;
            else if (data?.value) {
                this[`allUsers`].push(data);
                this.$emit("addCustomData", data);
            }
            this.handleChecked(data);
            // }
        },

        async getJurisdiction() {
            let url = "/api/v1/orbis/jurisdiction-master";
            await osintAxios
                .get(url)
                .then((response) => {
                    if (response && response.data) {
                        response.data.data.push({label: "United States Of America", value: "us"})
                        this.jurisdictionList = [{ group: "Jurisdiction", categories: response.data.data }];
                        this.$store.dispatch("storeAllJurisdiction", response.data.data);
                        
                    }
                })
                .catch(() => { });
        },

        getJurisdictionDisplayName(code) {
            return code;
        },

        getJurisdictionFlag(code) {
            code = code.toLowerCase();
            const country_code = code.split("_")[0];
            return this.$store.getters?.getIconsData?.find((e) => e.key == `flag_${country_code}`)?.icon_data ?? "";
        },





        showMore(id, code) {
            this.getMoreCompanyDetails(id, code);
        },
        async getMoreCompanyDetails(companyNumber, code) {
            let requestBody = {
                number: companyNumber,
                code: code,
            };
            const response = await osintAxios.post("/api/v1/company/search/id", requestBody);
            try {
                if (response && response.data && response.data.data) {
                    this.fullDetails = response.data.data;
                    map(this.domainCompanyDetailsSearch, (item) => (item.company.company_number === companyNumber ? extend(item, { more: this.fullDetails }) : item));
                    this.$set(this.readMore, companyNumber, true);
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                }
            } catch (error) { console.log(error) }
        },
        async getdomainCompanyDetails(i) {
            this.startLoader("companySearch");
            let requestBody = {
                domain: this.searchKeyword,
            };
            const response = await osintAxios.post("/api/v1/domain/company", requestBody);
            try {
                if (response && response.data && response.data.data) {
                    this.domainCompanyDetails = response.data.data;
                    // Calling company details Search
                    this.getdomainCompanyDetailsSearch(this.domainCompanyDetails.name, i);
                }
                this.resetLoader("companySearch");
                if (this.tabName === "tools") {
                    this.SET_ALL_TOOLS_DATA({
                        ...this._data,
                        "tool-name": "company-name",
                    });
                } else {
                    this.SET_ALL_MONITORING_DATA({
                        ...this._data,
                        "tool-name": "company-name",
                    });
                }
            } catch (error) { console.log("error") }
        },
        async getdomainCompanyDetailsSearch(companyName, i) {
            this.startLoader("companySearch");
            let requestBody = {
                name: companyName,
                code: this.jurisdiction?.value,
            };
            this.csvData = {
                company: [],
            };
            this.csvFields = [];
            const response = await osintAxios.post("/api/v1/company/search", requestBody, {
                headers: {
                    "x-tool-name": "company-name",
                    "x-visited": true,
                    ...this.autorun?.headers,
                },
            });
            try {
                if (i === 0) {
                    // this.successLoader();
                    if (response && response.data && response.data.data?.length) {
                        this.domainCompanyDetailsSearch = response.data.data;
                        // this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch.map((item) => item.company));
                        // this.csvFields = ["name", "registered_address_in_full", "company_number", "company_type", "jurisdiction_code", "updated_at", "current_status", "incorporation_date", "opencorporates_url", "registry_url"];
                        this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
                        this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
                        this.showResult = true;
                        this.showSearch = false;
                        this.$emit("searchResult", { data: this.domainCompanyDetailsSearch, source: "company", searchType: "name" });
                    } else if (response) {
                        this.$toast.error(this.$t('components.tools.poder.no_data_found'));
                    }
                    this.resetLoader("companySearch");
                    if (this.tabName === "tools") {
                        this.SET_ALL_TOOLS_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    } else {
                        this.SET_ALL_MONITORING_DATA({
                            ...this._data,
                            "tool-name": "company-name",
                        });
                    }
                }
            } catch (error) {
                this.resetLoader("companySearch");
            }
        },
        

        startLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = true;
        },
        successLoader(section) {
            this.loaderController[section].success = true;
            this.loaderController[section].loading = false;
        },
        resetLoader(section) {
            this.loaderController[section].success = false;
            this.loaderController[section].loading = false;
        },
        paginateTweets(pageNo) {
            this.pagination.tweets.page = pageNo;
            if (this.selectedTab === "tweets") {
                this.getTweets();
            }
        },
        formatDate(dt) {
            let parsed_dt = DateTime.fromISO(dt);
            if (!parsed_dt.invalid) return parsed_dt.toFormat("EEE, MMM dd yyyy");
            return dt;
        },

        getCount(count) {
            return count >= 1000 ? (count / 1000).toFixed(1) + "K" : count;
        },

        getTime(item) {
            let date = new Date(item.created_at);
            return date ? date.getDate() + "/" + (parseInt(date.getMonth(), 10) + 1) + "/" + date.getFullYear() : "";
        },

        async openShowMorePanel(company) {
            if(company.curr_index >= 0) {
                this.selectedCard = company.curr_index ;
            }
            else if(company.current_index >=0) this.selectedCard = company.current_index;
            this.isOldVersionSelected = false;
            this.companyDetails = this.judicialDetails[this.selectedCard];
            this.showMoreInfo = true;
            setTimeout(() => {
                document.getElementById(`company-${company.curr_index}`)?.scrollIntoView();
            }, 100);
        },
        async showMoreData(company) {
            // const handleExpandAllFlag = company?.handleExpandAllFlag;
            company = company.data.objAcuerdos.map(item => ({
                ...item,
                expand: false,
            }));
            let detailsExpanded = true;
            if (company.expand === false) detailsExpanded = false;
            if (detailsExpanded) {
                this.isComparisonModeOn = false;
                this.companyDetails = {...this.companyDetails};
            } 
                
            

            this.$forceUpdate();
        },

        async fetchReport(data) {
            let company = data.details;
            const bvd_id = data.id;
            if (!company.report_url) {
                company = {...company, isReportLoading: true};
                this.companyDetails = company;
                this.$forceUpdate();
                const report_url = `/api/v1/orbis/report`;
                const requestBody = {
                    bvd_id,
                    // company.company_number,
                    request_id: company?.api_all_data?.query_id,
                    card_type: company?.key === "bvd" ? "company" : "officer",
                    id_company: company.api_all_data.CONTACTS_MEMBERSHIP_IdCompany,
                    id_director: company.api_all_data.directorId,
                };
                try {
                    const resp = await osintAxios.post(report_url, requestBody);
                    if (resp.data.status) {
                        const pdf_url = `https://neotas-bvd-report-pdf.s3.amazonaws.com/${resp.data.filename}`;
                        company = {...company, report_url: pdf_url, isReportLoading: false};
                        this.companyDetails = company;
                    }
                } catch (error) {
                    this.$toast.error(this.$t('components.tools.poder.error_loading_full_report'));
                    company = {...company, isReportLoading: false};
                    this.companyDetails = company;
                }
                // this.showMoreInfo = true;
                // company.expanded = !company.expanded;
                this.companyDetails = company;
                this.$forceUpdate();
            }
        },

        clearFilters() {
            this.plantiff = "";
            this.page_number = 1;
            this.currentQuery = -1;
            this.status = "";
            this.defandantFilter = null;
            this.plantiffFilter = null;
            this.sourceTypeFilter = null;
            this.detailsFilter = null;
            this.locationFilter = null;
            this.caseTypeFilter = null;
            this.caseNumberFilter= null;
            this.fullName = "";
            this.companyFullName = "";
            this.showCurpId = false;
            this.showRFCId = false;
            this.curpId = "";
            this.rfcId = "";
            this.sourceType = "";
            this.jurisdictionType = "";
            this.filterJurisdiction = null
            this.dateRange = [];
            this.isAllRunQueries = false;
            this.setDefaultFilters();
            this.appliedFilterCount = 0;

            this.handleApplyFilters();
            this.setCardStatusCounts(true)
            // this.handleCloseMoreInfo();
        },
       
        /**
         * When tab is monitoring
         * Fetch monitoring results
         * @param {array} sources: []
         * @param {string} type: 'officer'/'company'/'address'
         */
        async monitoringSearch(sources, type) {
            this.sources = sources;
            this.showResult = true;
            this.showSearch = false;
            this.startLoader("companySearch");
            this.searchedClicked = true;
            if (this.latestVersionResultsCount == this.domainCompanyDetailsSearch.length) {
                this.apiCallPages = 1;
                this.page_number = 1;
                this.domainCompanyDetailsSearch = [];
            }
            let offset = 0;
            //To navigate to a different URL, according to the selected query
            this.redirectTo();
            const monitoringFilters = {
                startDate: this.dateRange[0],
                endDate: this.dateRange[1],
                dataType: this.selectedDataType.value
            }
            let values = await monitoringSearchData(this.getNeoCaseId, sources, this.$route.query.check_name, monitoringFilters, this.getSelectedToolQuery, offset);
            this.latestVersionResultsCount = values.totalResults;
            // opencorporates
            let open_corporates,
                clarifiedBy,
                companyWatch,
                bvd = [];
            if (type === "company") {
                open_corporates = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "opencorporates"),
                    "openCorporates",
                    CORPORATE_TOOL_MAPPING
                );
                clarifiedBy = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "clarifiedby"),
                    "clarifiedBy",
                    CORPORATE_TOOL_MAPPING
                );
                companyWatch = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "companywatch"),
                    "companyWatch",
                    CORPORATE_TOOL_MAPPING
                );
                bvd = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "bvd"),
                    "bvd",
                    CORPORATE_TOOL_MAPPING
                );
            } else {
                open_corporates = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "opencorporates"),
                    "officer",
                    CORPORATE_TOOL_MAPPING,
                    "openCorporates"
                );
                clarifiedBy = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "clarifiedby"),
                    "officer_clarifiedBy",
                    CORPORATE_TOOL_MAPPING,
                    "clarifiedBy"
                );
                companyWatch = this.getMappingValue(
                    values?.values?.filter((val) => val.doc_source === "companywatch"),
                    "officer_companyWatch",
                    CORPORATE_TOOL_MAPPING,
                    "companyWatch"
                );
                let results = [];

                values?.values
                    ?.filter((val) => val.doc_source === "bvd")
                    .forEach((officer) => {
                        let start = results.length;
                        results.push(officer);
                        for (let i = start; i < results.length; i++)
                            results[i] = {
                                ...results[i],
                                officerName: officer.CONTACTS_HEADER_FULLNAME,
                                directorId: officer.CONTACTS_HEADER_IdDirector,
                                country: officer.CONTACTS_HEADER_HomeCountry,
                                doc_source: officer.doc_source,
                                monitoring_id: officer.monitoring_id,
                                monitoring_result_status: officer.monitoring_result_status,
                                changes_viewed: officer.changes_viewed,
                                // monitoring_status: officer.monitoring_status,
                                monitoringDate: officer.monitoringDate,
                                // monitoring_result_flag: officer.
                                // mon_src._source.data.monitoring_result_status = mon_src._source.status;
                                // mon_src._source.data.monitoring_status = mon_src.monitoring_status;
                            };
                    });

                results = uniqBy(
                    results.map((item) => ({
                        ...item,
                        key: "officer_bvd",
                    })),
                    "CONTACTS_MEMBERSHIP_IdCompany"
                );
                bvd = this.getMappingValue(results, "officer_bvd", CORPORATE_TOOL_MAPPING, "bvd");
            }
            // const monitoringDocIds = open_corporates.map((res)=>res.api_all_data.doc_id)
            // this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.filter((res)=>!monitoringDocIds.includes(res.api_all_data.doc_id))
            this.domainCompanyDetailsSearch = [...open_corporates, ...clarifiedBy, ...bvd, ...companyWatch];
            this.domainCompanyDetailsSearch = this.domainCompanyDetailsSearch.map((ele, index) => ({...ele, current_index: index}));
            this.cardStatusResults = this.domainCompanyDetailsSearch
            await this.getAllCardsDetails();
            this.setCardStatusCounts();
            this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name })
            this.csvData.company = this.convertToCSV(this.domainCompanyDetailsSearch);
            this.csvFields = ["company_number", "company_name", "status", "address", "company_type", "jurisdiction", "incorporation_date"];
            this.resetLoader("companySearch");
            this.$emit("getInitialQueryCount");
        },
        checkConfig(sourcesResponse) {
            let message = []
            sourcesResponse.forEach((source)=>{
                if (source?.data?.status_code == 2004) {
                    message.push(source?.data?.message)
                }
            })
            return message
        },

        async updateEntityType() {
            await this.clearFilters();
            // this.setExpandSection();
            const entityName = this.getSelectedEntity?.entity_name;
            if (this.getSelectedEntity?.entity_type=='Company' && this.entityType == 'company' ) {
                this.entityType = 'company'
                this.companyFullName = {
                    value: entityName
                };
                this.curpId = "";
                this.rfcId = "";
                this.showCurpId = false;
                this.showRFCId = false;
            }
            else if  (this.getSelectedEntity?.entity_type=='Person' && this.entityType == 'person') {
                this.entityType = 'person';
                this.fullName = {
                    value: entityName
                }
                this.curpId = "";
                this.rfcId = "";
                this.showCurpId = false;
                this.showRFCId = false;
            }
        },

        resetFilter() { 
            this.judicialDetails = [];
        },
        
        async search(refreshFlag, filtersSection) {
            this.judicialDetails = [];
            this.timeline = [];
            this.setCardStatusCounts()
            this.tabsStatus.selected = 'all';
            this.selectedCard =  null;
            this.companyDetails =null;
            this.showMoreInfo = false;
            this.page_number = 1
            this.items_count = 10
            this.curpInfo = null;
            this.rfcInfo = null;
            if (!filtersSection) {
                this.setDefaultFilters()
                this.showFiltersPanel = false
            }
            this.searchClicked = true;
            if (this.apiCallPages == 1) this.page_number = 1;
           
            
            this.isSavedLoading = {
                loading: false,
                loadingCardIndex: null,
            };
            this.isOldVersionSelected = false;
           
            // let list = [];
            // let start 
            // if (this.currentQuery >= 0)
           
                // this.showResult = false;
                this.plantiff = "";
                this.status = "";
                this.sourceType = "";
                this.jurisdictionType = "";
                this.searchQuery = "";
                this.triggerRoute = false;
                if (this.apiCallPages == 1) this.judicialDetails = [];
                const headers = {
                    "x-tool-name": "poder-tool",
                    "x-visited": true,
                    "x-refresh": refreshFlag || false,
                    "x-entity-id": this.$route.query.entityId,
                    ...this.autorun?.headers,
                };
                let sources = ["poder"];
                if(this.curpId && this.showCurpId && !this.rfcId && !this.showRFCId) this.searchKeyword = this.curpId;
                else if(this.rfcId && this.showRFCId && !this.curpId && !this.showCurpId) this.searchKeyword = this.rfcId;
                else if (this.entityType === "company") this.setCompanyName();
                else this.setPersonName();
                if ((this.searchKeyword) || this.isAllRunQueries) {
                    if (!this.isAllRunQueries && sources?.length === 0) {
                        this.showResult = false
                        return;
                    }
                    
                    this.startLoader("companySearch");
                    this.csvData = {
                        company: [],
                    };
                    this.csvFields = [];
                    
                    
                    // request_id
                    // query.sources = sources.join(",");
                    
                let payload = {};
                payload.sources = sources;
                if(this.entityType.toLowerCase() === 'person') {
                    if(this.fullName && !this.showCurpId && !this.showRFCId) {
                        if(this.searchMode.value.value === "exact_match")
                            payload.exact_name = this.fullName.value;
                        else payload.full_name = this.fullName.value;
                    }
                    if(this.curpId && this.showCurpId) {
                        payload.curp_id = this.curpId;
                    }
                }
                else {
                    if(this.companyFullName && !this.showCurpId && !this.showRFCId) {
                        payload.company_name = this.companyFullName.value;
                    }
                    if(this.showRFCId && this.rfcId) {
                        payload.rfc_id = this.rfcId;
                    }
                }
                const {data: sourcesCall} = await osintAxios.post("/api/v1/litigation/search_sources", payload, {headers});
                payload.request_id = sourcesCall.request_id;
            
                const queryExists = this.searchedQueries.some((res)=>res._id==sourcesCall.request_id)
                if (!queryExists) {
                    this.monitoringActive = false
                }
                this.request_id = sourcesCall.request_id;
                this.redirectTo();
                let poder
                 if(this.entityType == 'person') {
                    if(this.showCurpId) {
                        poder = await osintAxios.post("/api/v1/poder/person/search/curp", payload,  {headers});
                    }
                    if(this.searchMode.value.value === "exact_match" && this.fullName?.value?.length>0 && !this.showCurpId) {
                        poder = await osintAxios.post("/api/v1/poder/person/search/exact_name", payload, {headers});
                    }
                    else if(this.fullName?.value?.length && !this.showCurpId) {
                        poder = await osintAxios.post("/api/v1/poder/person/search/full_name", payload, {headers});
                    }
                } else if(this.showRFCId) {
                    poder = await osintAxios.post("/api/v1/poder/company/search/rfc", payload, {headers});
                } else if(this.entityType === 'company' && this.companyFullName) {
                    poder = await osintAxios.post("/api/v1/poder/company/search/name", payload, {headers});   
                }
                    
                
                    this.$emit("searched", {data: this.searchKeyword, source: "poder"});
                    await this.setSearchedUser(this.searchKeyword , "company_name");
                    this.showResult = true;
                    this.showSearch = false;
                    
                    if (poder) {
                        this.totalCount = poder?.data?.total_results
                        if (this.apiCallPages === 1) this.judicialDetails = [];
                        // if(poder.data?.curp_info)
                        //     this.curpInfo = poder?.data?.curp_info
                        // if(poder.data?.rfc_info)
                        //     this.rfcInfo = poder.data?.rfc_info
                        await Promise.allSettled([poder])
                            .then(async (results) => {
                                let values = results.map((result) => result.value);
                                
                                if (this.apiCallPages === 1) this.domainCompanyDetailsSearch = [];
                                // orbis
                                const poderData = values[0]?.data?.data;
                                
                                if (poderData?.length > 0) {
                                    this.judicialDetails = poderData;
                                    this.showSearch = false;
                                    if(poderData[0]?.data?.curp_info)
                                        this.curpInfo = poderData[0]?.data?.curp_info
                                    if(poderData[0]?.data?.rfc_info)
                                        this.rfcInfo = poderData[0]?.data?.rfc_info
                                }
                                if ((!results[0]?.status === "rejected" && values[0] && (!values[0]?.data?.data || values[0]?.data?.data?.length === 0)) ) {
                                    if (values[0]?.data?.message) this.$toast.error(values[0]?.data?.message);
                                    else this.$toast.error(this.$t('components.tools.poder.no_data_found'));
                                }
                                if (results[0]?.status === "rejected" || values[0]?.status === 500) {
                                    this.showSearch = false;
                                    this.showResult = true;
                                    this.$toast.error(this.$t('components.tools.poder.poder_something_went_wrong_please_try_again'));
                                }
                                this.cardStatusResults = this.judicialDetails
                                
                                
                                    await this.getAllCardsDetails()
                                    this.setCardStatusCounts()
                                
                                
                                this.SET_ALL_TOOLS_DATA({
                                    ...this._data,
                                    "tool-name": "poder-tool",
                                });
                                this.triggerRoute = true;
                                if(this.fullName)
                                    this.$emit("searchResult", {data: this.judicialDetails, source: "poder", searchType: "name"});
                                if(this.companyFullName)
                                    this.$emit("searchResult", {data: this.judicialDetails, source: "poder", searchType: "company_name"});
                                if (this.judicialDetails.length <= 0) {
                                    this.totalResults = 0;
                                } else {
                                    this.judicialDetails = this.judicialDetails.map((ele, index) => ({...ele, current_index: index}));
                                    this.totalResults = this.judicialDetails.length;
                                }
                                this.resetLoader("companySearch");
                                let configMissing = this.checkConfig(values)
                                if (configMissing.length>0) {
                                    configMissing.forEach((mes)=>{
                                        this.$toast.error(mes)
                                    })
                                    return
                                }
                                this.$emit("updateQueryTotal", { checkName: this.$route.query.check_name });
                                await this.afterSearchResponseReceived({ 
                                    searchResults: results 
                                });
                                this.$emit("updateToolData", "poder-tool");
                                
                            })
                            .catch((error) => {
                                if (error.response && error.response.status === 406) {
                                    const message = error.response?.data?.detail || "Something went wrong. Please try again.";
                                    this.$toast.error(message);
                                }
                                this.showSearch = false;
                                this.showResult = true;
                                this.resetLoader("companySearch");
                            });
                    }
                }
            
            this.isloadingDetails = false;
            this.isLoading = false;
        },
        
        bypassCache() {},
        redirectToQuery(dataRes) {
            if (this.$route?.query?.query_id) {
                this.apiCallPages = 1;
                let {query_id} = this.$route.query;
                let selected_query = this.toolSearchQueries?.find((el) => el._id === query_id);
                const {sources, code, mode} = selected_query?.query;
                let q, type;
                if (selected_query?.query?.name) {
                    q = selected_query?.query?.name;
                    type = "company";
                } else if (selected_query?.query?.officer) {
                    q = selected_query?.query?.officer;
                    type = "officer";
                } else if (selected_query?.query?.address) {
                    q = selected_query?.query?.address;
                    type = "address";
                }
                if (q && type) {
                    switch (type) {
                        case "company":
                            // this.searchKeyword, this.officer, this.address
                            this.officer = "";
                            this.address = "";
                            this.searchKeyword = q;
                            if (code) {
                                this.jurisdiction = this.jurisdictionList[0].categories.find((n) => n.value === code);
                            }
                            if (mode) {
                                let search_mode_find = this.searchMode?.props?.options?.find((ele) => ele.value === mode);
                                this.searchMode.value = search_mode_find;
                            }
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.selectedItem = {
                                value: q,
                            };
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            break;
                        case "officer":
                            this.searchKeyword = "";
                            this.address = "";
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.officer = q;
                            this.fieldType = {
                                text: "Officer",
                                value: "officer",
                            };
                            if (code) {
                                this.jurisdiction = this.jurisdictionList[0].categories.find((n) => n.value === code);
                            }
                            if (mode) {
                                let search_mode_find = this.searchMode?.props?.options?.find((ele) => ele.value === mode);
                                this.searchMode.value = search_mode_find;
                            }
                            break;
                        case "address":
                            this.searchKeyword = "";
                            this.officer = "";
                            this.registry.firstName = "";
                            this.registry.middleName = "";
                            this.registry.lastName = "";
                            this.registry.nickname = "";
                            this.address = q;
                            this.fieldType = {
                                text: "Address",
                                value: "address",
                            };
                            break;
                        default:
                            break;
                    }
                    this.selectVal = [q];
                    if (sources) {
                        this.openCorporatesCheck = sources.includes("opencorporates");
                        this.clarifiedByCheck = sources.includes("clarifiedby");
                        this.companyWatchCheck = sources.includes("companywatch");
                        this.bvdCheck = sources.includes("bvd");
                        this.dnbCheck = sources.includes("db");
                    }
                    if (!dataRes) this.search();
                } else if (this.selectedItem && this.searchKeyword) {
                    if (!dataRes) {
                        this.search();
                    } else {
                        this.triggerRoute = false;
                        this.redirectTo();
                    }
                }
            } else {
                this.redirectTo();
            }
        },
        redirectTo() {
            let query = this.$route.query;
            if (this.request_id)
                query = {
                    ...query,
                    query_id: this.request_id,
                };

            this.$router.push({path: this.$route.path, query}).catch(() => {});
        },
        clipboardCheck() {
            return this.fieldType.value === "officer";
        },
        getTable(level) {
            let copyData = this.judicialDetails;
            if (level === "L3") {
                return `<table width="100%" cellpadding="9" cellspacing="2" style=" font-size: 11pt !important; table-layout: fixed; width: 100%;"> <colgroup><col width="78"> <col width="81"> <col width="90"> <col width="62"> <col width="80"> <col width="90"> <col width="22"> </colgroup><thead> <tr> <td width="78" height="7" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company</b></p> </td> <td width="81" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company Number</b></p> </td> <td width="90" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important; color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company Status</b></p> </td> <td width="62" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role</b></p> </td> <td width="80" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Date Appointed</b></p> </td> <td width="90" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family: 'Lato', serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role Status</b></p> </td> <td width="22" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="color: white; width: 0.4in; margin: auto; font-family: 'Lato', serif !important; "> <img src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAACAklEQVRIidWVy2pTQRyHv0kDVpRGBS9E8bJzHQVRUOvGtm4sdiHqvq8g+hQ1utEXkK6LBXEhplURYpT0BWxFU1Gpt53g5yITPJ2cpKm7zmrON//b+c/Mb2CrjzCIkXoMOA0cAARWgZchhHf/nVkN6pTaUFvqL3VBXYzzVly7og5UaDZ4SZ1XX6tj6kl1Rd2h7lTfqyfiWkN9pJY2E7ypzqhDkd1Tb2Vsbqt347yoVqNP/ySxLfPqTMKX1Ermu6I2E5uqOrdRgqnYlqHkj36oxQwrRlZK2Bt1sl+ChjqWsFG1lmO7oJ5P2IRaz7JCZvEoUAaeJLH2Aa2celaBvQl7DByMx3p9Atrn/GkI4U/itAv4lpNgDdiTBdG3BpzqsGJmvQwcVm8mgc4CIzn8OFBWdyf8UIzVlQBgG5A6bAeGc/gw8LsH7x7qNfVhDp9W7+fwB+p0Dp9Vr3a+s3vwArigFhKftZwqod3/r0nwAnAOeNWVIISwDHwELiaBPtMWuXTsB74kbBz40FMEo3A1kktVUr8PeNHebnTRQhSuOwlv5kjFUmKTKxXr+h1CELhOey+qmaprQPaGjwPPMpVXgVHgRs/qk2pK6lzUlokozStRqjtyXVEvxbbMqSMDBU8STap19VN8ZBbV5+rPyOrq5X4xBn0yjwBn+HeaWrSfzOVNV73lxl+mLetSj8thHwAAAABJRU5ErkJggg=='/> </p> </td> </tr> </thead> <tbody>
                ${
                    copyData?.length > 0
                        ? copyData
                              .map((elem) => elem.api_all_data.officer)
                              .map(
                                  (ele) => `
                <tr> <td width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;">${ele?.company.name ? startCase(toLower(ele?.company.name)) : "&nbsp;"}</p> </td> <td width="81" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${
                    ele?.company?.company_number ?? "&nbsp;"
                }</p> </td> <td width="90" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${!ele.inactive ? "Active since " : "Dissolved "} <br/>  ${
                    !ele.inactive ? (ele?.start_date ? DateTime.fromISO(ele?.start_date).toFormat("dd MMM yyyy") : "&nbsp;") : ele?.end_date ? DateTime.fromISO(ele?.end_date).toFormat("dd MMM yyyy") : "&nbsp;"
                }</p> </td> <td width="62" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${ele?.position ? startCase(toLower(ele.position)) : "&nbsp;"}</p> </td> <td width="80" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${
                    ele?.start_date ? DateTime.fromISO(ele?.start_date).toFormat("dd MMM yyyy") : "&nbsp;"
                }</p> </td> <td width="90" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${!ele.inactive ? "Active " : "Dissolution "}</p> </td> <td width="22" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;"> ${ele?.jurisdiction_code ?? "&nbsp;"}</p> </td> </tr>
                `
                              )
                              .join("")
                        : `<tr> <td colspan="5" width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;">No information identified</p> </td></tr>`
                }
                 </tbody> </table>`;
            } else {
                return `<table width="100%" cellpadding="9" cellspacing="2" style=" font-size: 11pt !important; table-layout: fixed; width: 100%; "> <colgroup><col width="184"> <col width="213"> <col width="171"> </colgroup> <thead> <tr> <td colspan="3" width="597" height="21" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Directorships & Company Records</b></p> </td> </tr> <tr> <td width="184" height="28" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Company</b></p> </td> <td width="213" bgcolor="#0070c0" style="background: #0070c0"><p class="western" align="center" style="font-family:'Lato',serif !important;color:#ffffff;"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Role</b></p> </td> <td width="171" bgcolor="#0070c0" style="background: #0070c0"><p style="font-family:'Lato',serif !important;color:#ffffff;" class="western" align="center"> <b style="font-size:11.0pt !important;line-height:120%;font-family:&quot;Lato&quot;,sans-serif !important;">Dates of Appointment</b></p> </td> </tr> </thead>
                <tbody>
                ${
                    copyData?.length > 0
                        ? copyData
                              .map((elem) => elem.api_all_data.officer)
                              .map(
                                  (ele) =>
                                      `<tr> <td width="184" height="21" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;">${ele?.company?.name ? startCase(toLower(ele?.company?.name)) : "&nbsp;"}</p> </td> <td width="213" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;">${
                                          ele.position ? startCase(toLower(ele.position)) : "&nbsp;"
                                      }</p> </td> <td width="171" bgcolor="#E7E6E6" style="background: #E7E6E6"><p class="western" align="center" style="font-family:'Lato',serif !important;word-break: break-all;"> ${ele?.start_date ? DateTime.fromISO(ele.start_date).toFormat("MMM yyyy") : "&nbsp;"} - ${ele?.start_date ? (ele?.end_date ? DateTime.fromISO(ele?.end_date).toFormat("MMM yyyy") : "Present") : ""} </p> </td> </tr> `
                              )
                              .join("")
                        : `<tr> <td colspan="3" width="78" height="4" bgcolor="#e7e6e6" style="background: #e7e6e6"><p class="western" align="center" style="font-family: 'Lato', serif !important;word-break: break-all;">No information identified</p> </td></tr>`
                }
                </tbody>
                </table>`;
            }
        },
        async handleCopyToClipboard() {
            let level = "L1";
            // isEmpty
            let product = "";
            if (isEmpty(this.getCasePersonalData)) {
                let {data} = await blackAxios.get(`case-personal-data/${this.case_id}`);
                product = data.case_data?.data["Due Diligence Level"]?.value ?? "";
            }
            product = product ? product : this.getCasePersonalData?.data["Due Diligence Level"]?.value ?? "";
            if (product) {
                const {data} = await blackAxios.get("/product-mapper", {
                    params: {
                        product,
                    },
                });
                if (data?.data?.product_type) level = data?.data?.product_type;
            }
            let table_template = this.getTable(level);
            const el = document.createElement("div");
            el.innerHTML = table_template;
            el.setAttribute("id", "table-template");
            el.style.position = "absolute";
            el.style.left = "-9999px";
            document.body.appendChild(el);
            let social_media = document.getElementById("table-template");
            let range, sel;
            if (document.createRange && window.getSelection) {
                range = document.createRange();
                sel = window.getSelection();
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(social_media);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(social_media);
                    sel.addRange(range);
                }
                document.execCommand("copy");
            } 
            this.$toast.success(this.$t('components.tools.poder.copied_to_clipboard'));
        },
        // handleSourceChange(e) {
        // },
        backToSearch() {
            this.showMoreInfo = false;
            this.showSearch = true;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
            this.timeline = [];
            this.$emit("updateMonitoringCascadingTimeline", {
                timeline: this.timeline,
                meta_data: null,
            });
            const entityName = this.prebuiltQueryPayload?.name
            || this.getSelectedEntity?.entity_name;
            if(!this.fullName?.value?.length>0 && !this.companyFullName?.value?.length>0 && !this.rfcId.length>0 && !this.curpId.length>0) {
                if (this.getSelectedEntity?.entity_type=='Company') {
                    this.entityType = 'company'
                    this.companyFullName = {
                        value: entityName
                    };
                    this.curpId = "";
                    this.rfcId = "";
                    this.showCurpId = false;
                    this.showRFCId = false;
                }
                else if  (this.getSelectedEntity?.entity_type=='Person') {
                    this.entityType = 'person';
                    this.fullName = {
                        value: entityName
                    }
                    this.curpId = "";
                    this.rfcId = "";
                    this.showCurpId = false;
                    this.showRFCId = false;
                }
            }
            this.request_id = "";
            this.showResult = false
            this.monitoringActive = false;
            this.redirectTo();
        },
        handleCloseMoreInfo() {
            this.showMoreInfo = false;
            this.selectedCard = null;
            this.isOldVersionSelected = false;
        },
        async handlePageChange(page_number) {
            this.handleCloseMoreInfo();
            document.getElementById("corpor_rec").scrollTo({
                top: "0px",
                behavior: "smooth",
            });
            this.page_number = page_number;
            if (this.isAllRunQueries) {
                if (this.getTotalPages - 1 <= this.page_number && this.judicialDetails.length >= this.items_count * this.page_number) {
                    this.startLoader("companySearch");
                    await this.onRunAllQueries(null, "judicialDetails");
                    this.resetLoader("companySearch")
                }
            }
        },
        addEntity() {
            this.newEntity = {
                type: this.queries.length ? this.queries[this.queries.length - 1].type : this.fieldType,
                company: "",
                officer: "",
                address: "",
                registry: {
                    firstName: "",
                    middleName: "",
                    lastName: "",
                    nickname: "",
                },
                jurisdiction: null,
            };
            this.queries.push(this.newEntity);
            this.entityCount += 1;
            this.newEntity = null;
            this.selectVal.push("");
        },

        removeEntity(i) {
            if (i < 0) {
                if (this.queries?.length) {
                    switch (this.queries[0].type.value) {
                        case "company":
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            this.selectedItem = this.queries[0].company;
                            this.searchKeyword = this.selectedItem.value;
                            break;
                        case "officer":
                            this.fieldType = {
                                text: "Officer",
                                value: "officer",
                            };
                            this.officer = this.queries[0].officer;
                            this.searchKeyword = "";
                            break;
                        case "address":
                            this.fieldType = {
                                text: "Address",
                                value: "address",
                            };
                            this.address = this.queries[0].address;
                            this.searchKeyword = "";
                            break;
                        case "registry":
                            this.fieldType = {
                                text: "Registry Search",
                                value: "registry",
                            };
                            this.registry = this.queries[0].registry;
                            this.searchKeyword = "";
                            break;
                        default:
                            this.fieldType = {
                                text: "Company",
                                value: "company",
                            };
                            this.selectedItem = this.queries[0].company;
                            this.searchKeyword = this.selectedItem.value;
                            break;
                    }
                    this.queries.splice(0, 1);
                    this.entityCount -= 1;
                    this.newEntity = null;
                    this.selectVal.splice(0, 1);
                } else {
                    this.selectedItem = null;
                    this.searchKeyword = "";
                    this.selectVal[0] = "";
                }
            } else {
                this.selectVal.splice(i + 1, 1);
                this.queries.splice(i, 1);
                this.entityCount -= 1;
                this.newEntity = null;
            }
        },
        onSelect({value}, idx) {
            this.selectVal[idx - 1] = value;
            this.$refs["analysis-tool-input"][idx - 1].search = value;
        },
        close(idx) {
            if (idx === 1) {
                this.searchKeyword = this.selectVal[0];
                this.selectedItem = {
                    value: this.selectVal[0],
                };
                this.$refs["analysis-tool-input"][0].search = this.selectVal[0];
            } else {
                if (!this.queries[idx - 2].company) {
                    this.queries[idx - 2].company = {value: this.selectVal[idx - 1]};
                } else {
                    this.queries[idx - 2].company.value = this.selectVal[idx - 1];
                }
                this.$refs["analysis-tool-input"][idx - 1].search = this.selectVal[idx - 1];
            }
        },
        handleChange(event, idx) {
            this.selectVal[idx - 1] = event;
        },
        setPersonName() {
            let list = [];
            list.push(this.fullName?.value);
            this.searchKeyword = list.filter((el) => el).join(" ");
        },

        setCompanyName() {
            this.searchKeyword = this.companyFullName?.value ?? "";
        },
        async handleExpandAllPanel(data) {
            let company = data.details;
            const isValue = data.value || null;

            let panels = [{type:"Notifications"}]
            if (isValue === true) {
                company.expandedPanel = true;
            } else {
                company.expandedPanel = !company.expandedPanel;
            }
            // const waitForMs = ms => new Promise(res => setTimeout(res, ms))
            company = company.map(item => ({
                ...item,
                expand: false, // or true, or whatever value you want
              }));
            for (const ele of panels) {
                if (ele) {
                    
                        await this.showMoreData({...company});
                        // await waitForMs(1050); // wait for api calls
                    
                    company[`${ele.type}Expanded`] = false;
                }
                company = {...company, [`${ele.type}Expanded`]: company.expandedPanel}
                company = cloneDeep(company)
               
            }
            let detailsExpanded = true;
            if (company.detailsExpanded === false) detailsExpanded = false;

            if (detailsExpanded) {
                this.companyDetails = {...this.companyDetails, ...company};
            }

            this.$forceUpdate();
           
            if (this.isComparisonModeOn) this.updateComparisonReferences({...company, handleExpandAllFlag: false});
        },

        async handleMarkAsAllDone(event) {
            const visited = event.target.checked;
            let doc_id = [];
            let payload;
            this.judicialDetails.slice(this.items_count * (this.page_number - 1), this.page_number * this.items_count).forEach((result, index) => {
                // doc_id.push(result.api_all_data.monitoring_id)
                let sources = [];
                /**
                 * TO DO  - Bug number - wlprm-4612
                 * Right now there is no any key in api.all.data named as doc_source
                 * So I take reference from lexis code in function name handleMarkAsAllDone
                 * Here we passing the hardcoded value for source
                 * passing hard coded value "bvd"
                 * previous code line i commented - sources.push(result.api_all_data.doc_source)
                 * 
                 */
                // sources.push(result.api_all_data.doc_source)
                // sources.push("bvd"),
                payload = {
                    doc_id: result.api_all_data.doc_id,
                    sources: sources,
                    cascaded: result.api_all_data?.history_count ? true : false,
                };
                doc_id.push(payload);
                this.judicialDetails.slice(this.items_count * (this.page_number - 1), this.page_number * this.items_count)[index].api_all_data.changes_viewed = visited;
            });
            if (this.timeline.length > 0) {
                this.timeline = this.timeline.map((res) => {
                    let obj = res;
                    obj.api_all_data.changes_viewed = visited;
                    return obj;
                });
            }
            this.$forceUpdate();
            await blackAxios.post("/service/mark-monitered-data-visited", {
                card_info: doc_id,
                case_id: this.getNeoCaseId,
                visited,
            });
        },

        /**
         * @function
         * @name toggleAllSources - toggle selection of all sources
         */
        toggleAllSources() {
            if (!this.allSourcesChecked) {
                this.openCorporatesCheck = true;
                this.clarifiedByCheck = true;
                this.companyWatchCheck = true;
                this.bvdCheck = true;
            } else {
                this.openCorporatesCheck = false;
                this.clarifiedByCheck = false;
                this.companyWatchCheck = false;
                this.bvdCheck = false;
            }
        },

        async handleSavedCard(cardData) {
            this.isSavedLoading = {
                loading: true,
                loadingCardIndex: cardData.api_all_data.doc_id,
            };
            let source = cardData.sourceTag?.toLowerCase() ?? cardData.key?.toLowerCase();
            source = source === "address" ? "opencorporates" : source;
            let body = {
                sources: [source],
                doc_id: cardData.api_all_data.doc_id,
                saved: !cardData.api_all_data.saved,
                card_data: {
                    created_at: null,
                    updated_at: null,
                    case_id: this.case_id,
                    query_id: this.request_id,
                    tool: "tool-corporate-meta",
                    tool_name: this.$route.params.toolName,
                },
            };
            try {
                const {data} = await blackAxios.post(`osint-tools/card/mark-as-saved`, body);
                if (data && data.success) {
                    let allResults = cloneDeep(this.domainCompanyDetailsSearch);
                    let cardIndex = allResults.findIndex((res) => res.api_all_data.doc_id === cardData.api_all_data.doc_id);
                    let cardResult = allResults[cardIndex];
                    cardResult.api_all_data.saved = !cardResult.api_all_data.saved;
                    allResults.splice(cardIndex, 1, cardResult);
                    this.domainCompanyDetailsSearch = allResults;
                    if (this.companyDetails.api_all_data.doc_id === cardData.api_all_data.doc_id) {
                        this.companyDetails.api_all_data.saved = !this.companyDetails.api_all_data.saved;
                    }
                    // this.$toast.success(!cardData.api_all_data.saved ? 'Saved!' : 'Updated!' )
                    this.$toast.success(this.$t('components.tools.poder.updated'));
                    this.$emit("refreshQueries");
                    this.$forceUpdate();
                }
                this.isSavedLoading = {
                    loading: false,
                    loadingCardIndex: null,
                };
            } catch (error) {
                this.isSavedLoading = {
                    loading: false,
                    loadingCardIndex: null,
                };
            }
        },

        getFormattedTime(ts) {
            if (ts) {
                let date = new Date(ts).toISOString();
                date = DateTime.fromISO(date);
                return date.toFormat("dd MMM yyyy");
            }
            return "-";
        },

        async handleSearch() {
            this.isAllRunQueries = false;
            if (
                (this.officer || this.selectedItem) &&
                  this.BVDDateOfBirth?.drops[0]?.value||
                this.BVDDateOfBirth?.drops[1]?.value ||
                this.BVDDateOfBirth?.drops[2]?.value
              ) {
                if (!this.BVDDateOfBirth?.drops[0]?.value) {
                  this.$toast.error(this.$t('components.tools.poder.please_provide_the_dob'));
                  return;
                }
                if (!this.BVDDateOfBirth?.drops[1]?.value) {
                  this.$toast.error(this.$t('components.tools.poder.please_provide_the_dob'));
                  return;
                }
                if (!this.BVDDateOfBirth?.drops[2]?.value) {
                  this.$toast.error(this.$t('components.tools.poder.please_provide_the_dob'));
                  return;
                }
              }
            try {
                this.setQueryResultLoader(true);
                this.page_number = 1;
                let globalFilters = false;
                globalFilters = await this.checkGlobalFilters();
                if (!globalFilters) {
                    await this.manualSearch();
                    await this.getToolsStatus()
                }  
            } catch(e){
                console.error(e)
            } finally{
                this.setQueryResultLoader(false)
            }
        },
        showModal() {
        },
        async checkGlobalFilters() {
            if (this.nerFilters) {
                try {
                    const confirm = await this.$refs["modal-confirm"].show({
                        title: this.$t('components.tools.poder.confirm_reset_global_filters_title'),
                        message: this.$t('components.tools.poder.confirm_reset_global_filters'),
                        autoclose: false,
                    });
                    if (confirm) {
                        this.$emit("handleNerClear");
                        this.$refs["modal-confirm"].close();
                        return false;
                    } else return true;
                } catch (error) {
                    this.$refs["modal-confirm"].close();
                }
            } else return false;
        },

        async showMonitoringHistory(data) {
            // TODO check this condition when WLP 5.0 is ready
            if (this.autorun) return;

            let payload = data.payload;
            payload.case_id = this.getNeoCaseId
            let source = [];
            if (this.sources?.length > 0) {
                source = this.sources;
            }
            // delete payload.monitoringHistoryIndex;
            if (payload.monitoringHistoryIndex) {
                this.timeline = [];
                const values = await monitoringHistoryData(payload, source, this.$route.query.check_name);
                if (values?.length > 0) {
                    let open_corporates,
                        clarifiedBy,
                        companyWatch,
                        bvd = [];
                    if (this.fieldType.value === "company") {
                        open_corporates = this.getMappingValue(
                            values.filter((val) => val.doc_source === "opencorporates"),
                            "openCorporates",
                            CORPORATE_TOOL_MAPPING
                        );
                        clarifiedBy = this.getMappingValue(
                            values.filter((val) => val.doc_source === "clarifiedby"),
                            "clarifiedBy",
                            CORPORATE_TOOL_MAPPING
                        );
                        companyWatch = this.getMappingValue(
                            values.filter((val) => val.doc_source === "companywatch"),
                            "companyWatch",
                            CORPORATE_TOOL_MAPPING
                        );
                        bvd = this.getMappingValue(
                            values.filter((val) => val.doc_source === "bvd"),
                            "bvd",
                            CORPORATE_TOOL_MAPPING
                        );
                    } else {
                        open_corporates = this.getMappingValue(
                            values.filter((val) => val.doc_source === "opencorporates"),
                            "officer",
                            CORPORATE_TOOL_MAPPING,
                            "openCorporates"
                        );
                        clarifiedBy = this.getMappingValue(
                            values.filter((val) => val.doc_source === "clarifiedby"),
                            "officer_clarifiedBy",
                            CORPORATE_TOOL_MAPPING,
                            "clarifiedBy"
                        );
                        companyWatch = this.getMappingValue(
                            values.filter((val) => val.doc_source === "companywatch"),
                            "officer_companyWatch",
                            CORPORATE_TOOL_MAPPING,
                            "companyWatch"
                        );
                        let results = [];

                        values
                            .filter((val) => val.doc_source === "bvd")
                            .forEach((officer) => {
                                let start = results.length;
                                results.push(officer);
                                for (let i = start; i < results.length; i++)
                                    results[i] = {
                                        ...results[i],
                                        officerName: officer.CONTACTS_HEADER_FULLNAME,
                                        directorId: officer.CONTACTS_HEADER_IdDirector,
                                        country: officer.CONTACTS_HEADER_HomeCountry,
                                        doc_source: officer.doc_source,
                                        monitoring_id: officer.monitoring_id,
                                        monitoring_result_status: officer.monitoring_result_status,
                                        changes_viewed: officer.changes_viewed,
                                        // monitoring_status: officer.monitoring_status,
                                        monitoringDate: officer.monitoringDate,
                                        // monitoring_result_flag: officer.
                                        // mon_src._source.data.monitoring_result_status = mon_src._source.status;
                                        // mon_src._source.data.monitoring_status = mon_src.monitoring_status;
                                    };
                            });
                        // results = uniqBy(
                        //     results.map((item) => ({
                        //         ...item,
                        //         key: "officer_bvd",
                        //     })),
                        //     "CONTACTS_MEMBERSHIP_IdCompany"
                        // );
                        bvd = this.getMappingValue(results, "officer_bvd", CORPORATE_TOOL_MAPPING, "bvd");
                    }
                    this.timeline = [...this.timeline, ...open_corporates, ...clarifiedBy, ...bvd, ...companyWatch];
                    this.timeline = this.timeline.map((ele, index) => ({...ele, current_index: index, isOldVersion: true}));
                    this.timeline.forEach((res)=> {
                        res.card_status = this.cardDetailsMap[res.api_all_data.doc_id] && this.cardDetailsMap[res.api_all_data.doc_id].status!='None'  ? this.cardDetailsMap[res.api_all_data.doc_id].status : 'UNKNOWN'
                        res.customer_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].customer_notes : ''
                        res.research_notes =  this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].notes : ''
                        res.risk_categories = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id].risk_categories : []
                        res.bespoke = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.bespoke : []
                        res.entity_status = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.entity_status : 'Red'
                        res.screenshot = this.cardDetailsMap[res.api_all_data.doc_id] ? this.cardDetailsMap[res.api_all_data.doc_id]?.screenshot : {}
                    })
                }
                const parent = {
                    ...data.detail,
                    is_parent: true,
                };
                const meta_data = {
                    searchedQueryKeyword: this.searchedQueryKeyword,
                    fieldType: this.fieldType,
                    selectedQuery: this.selectedQuery,
                };
                this.updateMonitoringCascadingTimeline({
                    timeline: cloneDeep(this.timeline)
                        .reverse()
                        .concat([parent]),
                    meta_data: meta_data,
                });
                this.setCardStatusCounts()
            } else {
                this.timeline = [];
                this.updateMonitoringCascadingTimeline({
                    timeline: this.timeline,
                    meta_data: null,
                });
                this.setCardStatusCounts()
            }
        },

        updateComparisonReferences(details) {
            if (this.isComparisonModeOn) {
                const isOldVersion = details.isOldVersion;
                if (isOldVersion) {
                    this.updateMonitoringCascadingTimeline({
                        newData: details,
                    });
                } else {
                    const parent = {
                        ...details,
                        is_parent: true,
                    };
                     this.updateMonitoringCascadingTimeline({
                        newData: parent,
                    });
                }
            }
        },

        handleCorporateRecordsConfirmation(event) {
            this.$emit("recordsConfirmation", event);
        },
    },
};
